import { keys, reduce } from 'lodash'

import { getMostSpecificNonEventMenuPreference } from './customerPreferences'
import { MENU_TYPES } from './menuTypes'

export const makePreferredPaymentList = (preferences, payments, standUuid) => {
  const paymentPreferences = preferences.filter(preference => preference.type === 'Customer::PaymentPreference')
  const menuTypes = keys(MENU_TYPES)

  const preferredPaymentList = reduce(menuTypes, (result, menuType) => {
    const mostSpecific = getMostSpecificNonEventMenuPreference(paymentPreferences, menuType, standUuid)

    result[menuType] = mostSpecific.customerPaymentIds

    return result
  }, {})

  return preferredPaymentList
}

export default makePreferredPaymentList
